/* Product page in the Tattup design (templates/product.json): header like the collection page, shipping & returns
   sheet (own country first), short description «Mehr», video plays only while visible, «Passt dazu» recommendations.
   Loaded by snippets/pdp-tt-info.liquid and sections/pdp-tattup.liquid; runs once. No dependencies. */
(function () {
  'use strict';
  if (window.__pdpTtLoaded) return;
  window.__pdpTtLoaded = true;

  /* 1 · Header: body.header-out once the full header has scrolled away (same as custom.js does on other pages,
     which skips product pages). Only on the standard product template (.tt-pdp). */
  function initHeader() {
    if (!document.body.classList.contains('template-product') || !document.querySelector('.tt-pdp')) return;
    var body = document.body;
    var header = document.querySelector('.section-header');
    if (!header || !('IntersectionObserver' in window)) return;
    var pinnedAnn = function () {
      var a = document.querySelector('.section-announcement-bar');
      if (!a) return 0;
      var p = getComputedStyle(a).position;
      return p === 'sticky' || p === 'fixed' ? Math.round(a.getBoundingClientRect().height) : 0;
    };
    var io;
    var watch = function () {
      if (io) io.disconnect();
      io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        body.classList.toggle('header-out', !e.isIntersecting && e.boundingClientRect.top < 0);
      }, { rootMargin: '-' + pinnedAnn() + 'px 0px 0px 0px', threshold: 0 });
      io.observe(header);
    };
    watch();
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(watch, 150); });
  }

  /* 2 · Shipping & returns sheet */
  function norm(s) {
    return (s || '').replace(/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}]/gu, '').replace(/\s+/g, ' ').trim().toLowerCase();
  }
  /* N5: the Help Center entry «versandkosten» (one source) is rebuilt into: the visitor's own country as a highlighted card
     on top («DEIN LAND» / «YOUR COUNTRY»: lime frame, the facts big in white, plus the concrete delivery dates and the cutoff
     from the delivery calculator assets/tt-eta.js), all other regions below as quiet grey rows, long country lists folded
     away. Labels and values come from the entry itself («Versand: CHF 3.90»); the delivery time of the own country comes
     from the delivery config (dashboard «Lieferzeiten», e.g. the Liechtenstein special rule 1–2 days). */
  /* «Schweiz & Liechtenstein», «Andorra, Belgium, … and Sweden.» → single normalised names */
  function names(t) { return norm(t).replace(/[.:]+$/, '').split(/\s*(?:&|,|\/|\+|\bund\b|\band\b)\s*/).filter(Boolean); }
  /* own country card: delivery time from the config + dates and cutoff (refreshed every time the sheet opens) */
  function ownEta(sheet) {
    var card = sheet.querySelector('.tt-own');
    var api = window.TTEta && window.TTEta.info ? window.TTEta : null;
    if (!card || !api) return;
    var i = api.info(), custom = sheet.dataset.custom === '1', d = sheet.dataset;
    var dd = card.querySelector('[data-tt-own-days]');
    if (dd) dd.textContent = custom ? i.cline : (d.ownDays || '').replace('MIN', i.min).replace('MAX', i.max);
    var box = card.querySelector('.tt-own__eta');
    if (!box) { box = document.createElement('div'); box.className = 'tt-own__eta'; card.appendChild(box); }
    if (custom || !i.on) { box.hidden = true; return; }
    box.hidden = false;
    var esc = function (x) { return String(x).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var cut = i.shipToday ? (d.ownToday || '').replace('TIME', esc(i.cut)).replace('LEFT', esc(i.left)) : (d.ownNext || '').replace('DAY', esc(i.ship)).replace('TIME', esc(i.cut));
    box.innerHTML = '<span class="tt-own__k">' + esc(d.ownEta || '') + '</span>' +
      '<b class="tt-own__dates">' + esc((d.ownRange || '').replace('FROM', i.from).replace('TO', i.to)) + '</b>' +
      '<p class="tt-own__cut">' + cut + '</p>';
  }
  function groupRegions(sheet) {
    var body = sheet.querySelector('[data-tt-ship-body]');
    if (!body || body.dataset.ttGrouped) return;
    body.dataset.ttGrouped = '1';
    var country = norm(sheet.dataset.country);
    /* the rich text comes wrapped (metafield_tag) – work inside the element that holds the paragraphs */
    var host = body;
    while (host.children.length && host.querySelectorAll(':scope > p').length < 3 && host.firstElementChild && host.firstElementChild.tagName === 'DIV') host = host.firstElementChild;
    var nodes = Array.prototype.slice.call(host.children);
    var regions = [];
    var cur = null;
    var intro = [];
    nodes.forEach(function (n) {
      if (n.classList.contains('tt-sheet__ret')) return;
      var isHead = n.tagName === 'P' && n.children.length === 1 && n.firstElementChild.tagName === 'STRONG' &&
        norm(n.textContent) === norm(n.firstElementChild.textContent) && n.textContent.trim().length < 40;
      if (isHead) {
        cur = { head: n, name: n.textContent.replace(/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}]/gu, '').trim(), facts: [], list: null, other: [] };
        regions.push(cur);
      } else if (cur) {
        var st = n.querySelector('strong');
        var lab = st ? st.textContent.trim() : '';
        var val = st ? n.textContent.slice(n.textContent.indexOf(lab) + lab.length).trim() : '';
        if (st && /:$/.test(lab) && n.textContent.length > 80) cur.list = { label: lab.replace(/:$/, ''), text: val };
        else if (st && /:$/.test(lab) && val) cur.facts.push({ label: lab.replace(/:$/, ''), value: val });
        else cur.other.push(n);
      } else {
        intro.push(n);
      }
    });
    if (regions.length < 2) return;
    intro.forEach(function (n) { n.classList.add('tt-sheet__note'); });
    var el = function (tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; };
    /* own region: by its name first («Schweiz», «Schweiz & Liechtenstein»), else by its country list */
    var own = null;
    if (country) {
      regions.forEach(function (r) { if (!own && names(r.name).indexOf(country) !== -1) own = r; });
      var amp = function (t) { return ' ' + norm(t).replace(/&/g, 'and').replace(/[^a-z0-9äöüéèàçâêîôûëïñ ]+/g, ' ').replace(/\s+/g, ' ') + ' '; };
      regions.forEach(function (r) { if (!own && r.list && amp(r.list.text).indexOf(amp(country)) !== -1) own = r; });
    }
    var wrap = el('div', 'tt-regions');
    if (own) {
      var card = el('div', 'tt-own');
      var hd = el('div', 'tt-own__hd');
      var viaList = norm(own.name) !== country;
      hd.appendChild(el('span', 'tt-own__chip', sheet.dataset.own || ''));
      hd.appendChild(el('b', 'tt-own__name', sheet.dataset.country || own.name));
      card.appendChild(hd);
      if (viaList) card.appendChild(el('p', 'tt-own__sub', own.name));
      var dl = el('dl', 'tt-own__facts');
      own.facts.forEach(function (f) {
        var d = el('div'), v = el('dd', null, f.value);
        if (/liefer|deliver/i.test(f.label) && !/versand|shipping|gratis|free/i.test(f.label)) v.setAttribute('data-tt-own-days', '');
        d.appendChild(el('dt', null, f.label)); d.appendChild(v); dl.appendChild(d);
      });
      card.appendChild(dl);
      own.other.forEach(function (n) { n.classList.add('tt-own__more'); card.appendChild(n); });
      wrap.appendChild(card);
    }
    var ul = el('ul', 'tt-rows');
    ul.setAttribute('role', 'list');
    regions.forEach(function (r) {
      if (r === own) return;
      var li = el('li', 'tt-row');
      var top = el('div', 'tt-row__top');
      top.appendChild(el('span', 'tt-row__n', r.name));
      if (r.facts[0]) top.appendChild(el('span', 'tt-row__p', r.facts[0].value));
      li.appendChild(top);
      var rest = r.facts.slice(1).map(function (f, i) { return i === 0 ? f.value : f.label + ' ' + f.value; });
      if (rest.length) li.appendChild(el('p', 'tt-row__x', rest.join(' · ')));
      r.other.forEach(function (n) { n.classList.add('tt-row__x'); li.appendChild(n); });
      if (r.list) {
        var det = el('details', 'tt-row__c');
        det.appendChild(el('summary', null, r.list.label));
        det.appendChild(el('p', null, r.list.text));
        li.appendChild(det);
      }
      ul.appendChild(li);
    });
    wrap.appendChild(ul);
    regions.forEach(function (r) { if (r.head.parentNode) r.head.remove(); });
    nodes.forEach(function (n) { if (n.parentNode === host && !n.classList.contains('tt-sheet__note') && !n.classList.contains('tt-sheet__ret')) n.remove(); });
    var ret = host.querySelector(':scope > .tt-sheet__ret');
    if (ret) host.insertBefore(wrap, ret); else host.appendChild(wrap);
  }
  function initSheet() {
    var sheet = document.querySelector('[data-tt-sheet]');
    var trigger = document.querySelector('[data-tt-ship]');
    if (!sheet || !trigger) return;
    /* fixed layer must not live inside animated (transformed) columns */
    document.body.appendChild(sheet);
    var lastFocus = null;
    var open = function () {
      groupRegions(sheet);
      ownEta(sheet);
      lastFocus = document.activeElement;
      sheet.hidden = false;
      document.documentElement.classList.add('tt-sheet-open');
      var x = sheet.querySelector('.tt-sheet__x');
      if (x) x.focus({ preventScroll: true });
    };
    var close = function () {
      sheet.hidden = true;
      document.documentElement.classList.remove('tt-sheet-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    };
    trigger.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;
      open();
    });
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
    });
    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-tt-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sheet.hidden) close();
    });
  }

  /* 3 · Short description: «Mehr» only when the text is longer than two lines */
  function initDesc() {
    document.querySelectorAll('[data-tt-desc]').forEach(function (box) {
      var text = box.querySelector('.tt-desc__text');
      var btn = box.querySelector('[data-tt-more]');
      if (!text || !btn) return;
      var label = btn.textContent;
      var check = function () {
        if (box.classList.contains('is-open')) return;
        btn.hidden = text.scrollHeight <= text.clientHeight + 2;
      };
      btn.addEventListener('click', function () {
        var openNow = !box.classList.contains('is-open');
        box.classList.toggle('is-open', openNow);
        btn.textContent = openNow ? btn.dataset.less : label;
        btn.setAttribute('aria-expanded', String(openNow));
      });
      check();
      window.addEventListener('resize', check);
    });
  }

  /* 4 · Application video: plays (muted) only while visible; not by itself with "reduce motion" or the data saver
     (the controls still start it). Phones get a light 480p copy, desktop the sharp mp4. */
  function initVideo() {
    /* poster (data-poster) only shortly before the video comes into view – a poster attribute downloads at once */
    document.querySelectorAll('[data-pdpt-video] video[data-poster]').forEach(function (v) {
      var set = function () { if (v.dataset.poster) { v.poster = v.dataset.poster; v.removeAttribute('data-poster'); } };
      if (!('IntersectionObserver' in window)) { set(); return; }
      var o = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { set(); o.disconnect(); } }, { rootMargin: '600px 0px' });
      o.observe(v);
    });
    if (!('IntersectionObserver' in window)) return;
    var still = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) || (navigator.connection && navigator.connection.saveData);
    if (still) return;
    document.querySelectorAll('[data-pdpt-video] video').forEach(function (v) {
      if (v.__pdpt) return;
      v.__pdpt = true;
      v.muted = true;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !document.hidden) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
        });
      }, { threshold: 0.35 }).observe(v);
    });
  }

  /* 5 · «Passt dazu»: swap in the section rendered with Shopify's related recommendations */
  function initRecs() {
    document.querySelectorAll('[data-pdpt-recs][data-url]').forEach(function (block) {
      var load = function () {
      var url = block.dataset.url;
      if (!url) return;
      block.removeAttribute('data-url');
      fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.plpb--pdp-recs');
        var root = block.closest('.plpb--pdp-recs');
        if (!fresh || !root || !fresh.querySelector('.pdpt-card')) return;
        fresh.id = root.id;
        fresh.dataset.plpbInit = '1';
        root.replaceWith(fresh);
        initRail(fresh);
      }).catch(function () {});
      };
      /* only when the block comes near the viewport (speed) */
      if (!('IntersectionObserver' in window)) { load(); return; }
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); }
      }, { rootMargin: '600px 0px' });
      io.observe(block);
    });
  }
  /* same arrows as the collection-page rails (plp-tattup.js), for the swapped-in markup */
  function initRail(root) {
    var rail = root.querySelector('[data-plpb-rail]');
    var nav = root.querySelector('[data-plpb-nav]');
    if (!rail || !nav) return;
    var prev = nav.querySelector('[data-dir="-1"]');
    var next = nav.querySelector('[data-dir="1"]');
    var update = function () {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max;
      nav.hidden = max <= 0;
    };
    nav.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-dir]');
      if (!btn) return;
      var item = rail.querySelector(':scope > li');
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      var step = item ? item.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
      rail.scrollBy({ left: Number(btn.dataset.dir) * step, behavior: 'smooth' });
    });
    rail.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* 6 · The sticky reward bar decides on scroll whether it is shown (sticky-atc.js). With the page's own buy row hidden
     it would stay hidden on desktop until the first scroll – nudge its own check once, the bar code stays untouched. */
  function nudgeBar() {
    if (!document.querySelector('.tt-pdp') || !window.customElements) return;
    /* desktop (990 px +) has its own Add to cart in the page – there the bar keeps its original scroll behaviour */
    if (window.matchMedia('(min-width: 990px)').matches) return;
    customElements.whenDefined('sticky-atc').then(function () {
      setTimeout(function () { window.dispatchEvent(new Event('scroll')); }, 50);
    });
  }

  /* 7 · In-page Add to cart (desktop): same confirmation as the card buttons, the theme's product form does the add */
  function initAddedFlash() {
    var form = document.querySelector('product-form.tt-pdp');
    var labelEl = document.querySelector('[data-tt-added-label]');
    if (!form || !labelEl) return;
    form.addEventListener('on:cart:add', function (e) {
      if (e.target !== form) return; /* the sticky bar is its own product-form */
      var btn = form.querySelector('buy-buttons [name="add"].add-to-cart');
      if (!btn || btn.dataset.ttFlash) return;
      btn.dataset.ttFlash = '1';
      var html = btn.innerHTML;
      btn.textContent = labelEl.textContent;
      btn.classList.add('tt-added');
      setTimeout(function () {
        btn.innerHTML = html;
        btn.classList.remove('tt-added');
        delete btn.dataset.ttFlash;
      }, 1500);
    });
  }

  /* Savings chip «−28 %» next to the price: follows the selected size (variant price vs compare-at price) */
  function initSave() {
    document.addEventListener('on:variant:change', function (e) {
      var chip = document.querySelector('.tt-pdp [data-tt-save]');
      var v = e.detail && e.detail.variant;
      if (!chip) return;
      if (!v || !(v.compare_at_price > v.price)) { chip.hidden = true; return; }
      var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
      chip.textContent = (chip.getAttribute('data-tpl') || '').replace('PCT', pct);
      chip.hidden = false;
    });
  }

  /* Shipping ticket sub line («Lieferung bis 22.10. bei Bestellung in den nächsten 18 Std 28 Min»): written by the
     shop-wide delivery calculator assets/tt-eta.js. */

  /* Desktop gallery (one photo + thumbnails, pdp-tattup.css): ← / → switch the photo while the gallery is on screen
     (not while typing or with the shipping sheet open) – same as the arrows on the photo. */
  function initGalleryKeys() {
    var gal = document.querySelector('.tt-pdp .media-gallery .main-image');
    if (!gal || !window.matchMedia) return;
    var mq = window.matchMedia('(min-width: 990px)');
    document.addEventListener('keydown', function (e) {
      if (!mq.matches || e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var t = e.target;
      if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
      if (document.documentElement.classList.contains('tt-sheet-open')) return;
      var r = gal.getBoundingClientRect();
      if (r.bottom < 80 || r.top > window.innerHeight - 80) return;
      var btn = gal.querySelector('.slider-nav__btn[name="' + (e.key === 'ArrowLeft' ? 'prev' : 'next') + '"]');
      if (btn && !btn.disabled) { e.preventDefault(); btn.click(); }
    });
  }

  /* Packungs-Karte (snippets/tt-pack-card.liquid, last gallery slide): a tap / click on the card (keyboard: its hidden
     button) shows the same card full size in a dialog – on phones the slide is only ~150 px wide. The zoom viewer
     only lists photos, so the card is not part of it. */
  function initPackCard() {
    var card = document.querySelector('.tt-pdp .main-image [data-tt-pack]');
    if (!card || typeof HTMLDialogElement !== 'function') return;
    var dlg = null;
    card.addEventListener('click', function (e) {
      e.preventDefault();
      if (!dlg) {
        dlg = document.createElement('dialog');
        dlg.className = 'tt-pack-dlg';
        var eye = card.querySelector('.tt-pack__eye');
        if (eye) dlg.setAttribute('aria-label', eye.textContent.trim());
        var copy = card.cloneNode(true);
        copy.removeAttribute('data-tt-pack');
        var hb = copy.querySelector('[data-tt-pack-open]');
        if (hb) hb.parentNode.removeChild(hb);
        /* the stamp's ring text path needs a unique id */
        Array.prototype.forEach.call(copy.querySelectorAll('[id]'), function (el) {
          var id = el.id;
          el.id = id + '-dlg';
          Array.prototype.forEach.call(copy.querySelectorAll('[href="#' + id + '"]'), function (u) { u.setAttribute('href', '#' + id + '-dlg'); });
        });
        var img = copy.querySelector('.tt-pack__pic img');
        if (img) { img.loading = 'eager'; img.sizes = '(min-width: 600px) 520px, 92vw'; }
        var x = document.createElement('button');
        x.type = 'button';
        x.className = 'tt-pack-dlg__x';
        x.setAttribute('aria-label', card.getAttribute('data-close') || 'Close');
        x.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
        x.addEventListener('click', function () { dlg.close(); });
        copy.appendChild(x);
        dlg.appendChild(copy);
        dlg.addEventListener('click', function (ev) { if (ev.target === dlg) dlg.close(); });
        document.body.appendChild(dlg);
      }
      dlg.showModal();
    });
  }

  function init() {
    initSave();
    initGalleryKeys();
    initPackCard();
    initAddedFlash();
    nudgeBar();
    initHeader();
    initSheet();
    initDesc();
    initVideo();
    initRecs();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
